// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(ElementUI)


import VueAMap from "vue-amap";

 

Vue.use(VueAMap);

 

VueAMap.initAMapApiLoader({

  key: 'lkfrmh92341s9fli34o18dc24a32417',

 plugin: [

   "AMap.Autocomplete",

   "AMap.PlaceSearch",

   "AMap.Scale",

   "AMap.OverView",

   "AMap.ToolBar",

   "AMap.MapType",

   "AMap.PolyEditor",

   "AMap.CircleEditor",

   "AMap.Geocoder"

 ],

 // 默认高德 sdk 版本为 1.4.4

 v: "1.4.4"

});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js